const repeat = (
  fn,
  maxWaitingTime = 30000,
  description = 'No UpLift node found on the page'
) => {
  let timeoutTimer, successTimer;

  const clearTimers = () => {
    clearInterval(successTimer);
    clearTimeout(timeoutTimer);
  };

  const timeout = new Promise(
    (resolve, reject) =>
      (timeoutTimer = setTimeout(() => {
        clearTimers();
        reject(description);
      }, maxWaitingTime))
  );

  const success = new Promise(resolve => {
    successTimer = setInterval(() => {
      if (fn()) {
        clearTimers();
        resolve(fn());
      }
    }, 100);
  });

  return Promise.race([success, timeout]);
};

export default {
  forElementToExist: (selector, timeout) =>
    repeat(() => document?.querySelectorAll(selector).length, timeout),
  forContentToExist: (selector, timeout) =>
    repeat(() => {
      const node = document?.querySelector(selector);
      const value = node?.querySelector('[data-g4-from-currency-unit-major]')
        ?.textContent;
      return value;
    }, timeout),
};
